import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const PostsWrapper = styled.div`
  background-color: ${({ theme }) => theme.default.color.backgrounds.light};
  padding: 1rem;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    justify-content: space-between;
  }
  button {
    font-size: 11px;
    gap: 4px;
  }
`;

export const DividerWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: ${defaultBreakpoints.medium}) {
    width: 100%;
  }
`;
